<template>
  <div class="col txt-bold">
    <el-popover placement="top-end" :width="350" :visible="this.compliance?.status === 6 && this.showPopUp" :hide-after="3000">
      <h5 class="text-purple initial-align break">
        Notification
      </h5>
      <p class="initial-align break text-break">N'oubliez pas de renvoyer votre dossier une fois les documents déposés</p>
      <button class="btn btn-purple-inverted max-content mt-2" v-on:click="sendCompliance">Envoyer mon dossier</button>
      <template #reference>
        <file-pond
            name="test"
            ref="pond"
            allow-remove="true"
            label-idle="Glissez et déposez vos fichiers..."
            v-bind:allow-multiple="true"
            v-bind:files="this.files"
            v-on:addfile="showModalDocument"
            v-on:removefile="handleFileRemove"
        />
      </template>
    </el-popover>
    <Transition name="modal">
      <div v-if="showModal" class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <span><fa icon="question-circle" class="fa-2xl"></fa><h3 class="ml-3">Type de document</h3></span>
            </div>
            <div class="modal-body">
              <p>Sélectionner le type de pièce</p>
              <select required v-model="documentType" class="form-control">
                <option v-for="type in availableDocuments" v-bind:key="type.code" :value="type.code">{{ type.label }}</option>
                <option value="other">Autres</option>
              </select>
            </div>
            <div class="modal-footer">
              <button class="btn btn-purple" v-on:click="cancelUpload">Annuler</button>
              <button class="btn btn-purple" v-on:click="addNewFile">Confirmer</button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>

import vueFilePond from "vue-filepond";
import compliance from "../services/compliance.service";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-get-file/dist/filepond-plugin-get-file.min.css";
import FilePondPluginGetFile from 'filepond-plugin-get-file';
import {base64ToBlob} from "@/helpers/tools";


const FilePond = vueFilePond(
    FilePondPluginGetFile,
);

export default {
  components: {
    FilePond,
  },
  name: 'FileManagerCompliance',
  props: ['compliance', 'documents', 'availableDocuments'],
  data() {
    return {
      files: [],
      idSimulation: this.$route.params.idFunding,
      showModal: false,
      documentType: null,
      currentFile: null,
      showPopUp: false,
    }
  },
  methods: {
    sendCompliance() {
      this.$emit('sendCompliance')
    },
    async getFilesFromApi(){
      await compliance.getComplianceFile(this.compliance.rowid).then(async(response) => {
        this.sentDocument(response.data);
        for (let i = 0; i < response.data.length; i++) {
          let file = response.data[i];
          await compliance.downloadComplianceFile(this.compliance.rowid, file.name).then(async(response) => {
            let blob = base64ToBlob(response.data.content, response.data.contentType)
            let finalFile = new File([blob], file.name, {type: response.data['content-type']});
            finalFile.baseInitFilePond = true;
            finalFile.keywords = file.keywords;
            const fileItem = await this.$refs.pond.addFile(finalFile, { metadata: { docType: file.keywords }});
            this.showDocType(fileItem);
          }).catch(() => {
            this.$notify({
              duration: 3000,
              text: 'Erreur lors de la récuperation d\'un document',
              type: 'error'
            });
          })
        }
      }).catch((error) => {
        if(error.response.status === 404){
          return;
        }
        this.$notify({
          duration: 3000,
          text: 'Erreur lors de la récuperation de la liste des documents',
          type: 'error'
        });
      })
    },
    resetFileManager(){
      this.showModal = false;
      this.currentFile = null;
      this.documentType =  null;
    },
    cancelUpload(){
      this.$refs.pond.removeFile(this.currentFile)
      this.resetFileManager()
    },
    showModalDocument(error, file){
      if(!file.file.baseInitFilePond){
        this.currentFile = file;
        this.showModal = true;
      }
    },
    sentDocument(documents){
      this.$emit('documentSent', documents.map(doc => doc.keywords));
    },
    getDocLabel(code) {
      if (code === 'other') return 'Autres';
      const match = Array.isArray(this.documents)
        ? this.documents.find(d => d.code === code)
        : null;
      return match?.label ?? code;
    },
    showDocType(fileItem) {
      const type = fileItem.getMetadata && fileItem.getMetadata('docType');
      if (!type) return;
      const label = ' - ' + this.getDocLabel(type);

      requestAnimationFrame(() => {
        const main = document.querySelector(`#filepond--item-${fileItem.id} .filepond--file-info-main`);
        if (!main) return;
        let badge = main.querySelector('.filepond--file-info-type');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'filepond--file-info-type';
          main.appendChild(badge);
        }
        badge.textContent = label.charAt(0).toUpperCase() + label.slice(1);
      });
    },
    addNewFile(){
      if(this.documentType === null){
        this.showNotification({text: 'Le type de document doit être saisi', type: 'warn'});
        return
      }
      this.currentFile.setMetadata('docType', this.documentType);
      this.showDocType(this.currentFile);
      this.showPopUp = true;
      this.processBase64(this.currentFile.file);
    },
    handleFileRemove(error, file){
      const currentFile = file.file;
      if (!currentFile.baseInitFilePond) return;

      const keywords = file.file.keywords || '';

      const showNotification = (text, type = 'info') => {
        this.$notify({ duration: 3000, text, type });
      };

      const restoreFile = () => {
        this.$refs.pond.addFile(currentFile);
      };

      if (keywords === 'pv' || keywords === 'contrat') {
        showNotification('Ce document ne peut pas être supprimé', 'warn');
        restoreFile();
        return;
      }

      if (!keywords) {
        showNotification("Ce document n'a pas de type spécifié", 'error');
        restoreFile();
        return;
      }

      compliance.deleteComplianceFile(
          this.compliance.rowid,
          'fin_conformite',
          file.file.name
      ).then(() => {
        showNotification('Le document a été supprimé avec succès', 'success');
        this.$emit('documentRemoved', keywords);
      }).catch(() => {
        showNotification('Erreur lors de la suppression du document', 'error');
        restoreFile();
      });
    },
    sendFile(file,base64file){
      const base64String = base64file
          .replace('data:', '')
          .replace(/^.+,/, '');
      compliance.postComplianceFile(this.compliance.rowid, file, base64String, this.documentType).then(() => {
        this.currentFile.file.baseInitFilePond = true;
        this.currentFile.file.keywords = this.documentType;

        this.$emit('documentNewSent', this.documentType);
          this.resetFileManager();
          this.$notify({
            duration: 3000,
            text: 'Le document a été envoyé',
            type: 'success'
          });
        }).catch(() => {
          this.$notify({
            duration: 3000,
            text: 'Erreur lors de l\'envoi du document',
            type: 'error'
          });
          this.$refs.pond.removeFile(file)
      });

    },
    processBase64(file) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        await this.sendFile(file, reader.result)
      };
      reader.onerror = () => {
        this.$notify({
          duration: 3000,
          text: 'Erreur lors de conversion en base 64',
          type: 'error'
        });
        return false;
      };
    },
  },
  mounted() {
    if(this.idSimulation && ![8,5].includes(this.compliance.status)){
      this.getFilesFromApi();
    }
  }
}
</script>

<style scoped>

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 30%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  max-width: 80%;
}

.modal-header span{
  display: flex;
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

:deep(.filepond--file-info-type) {
  white-space: nowrap;
  font-weight: bold;
}

:deep(.filepond--download-icon) {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    margin-right: 0;
    z-index: 102;
}
</style>
